import gql from 'graphql-tag'

export const sendPdfRequest = gql`
  mutation SendPdfRequest(
    $accountId: Int!
    $userId: Int!
    $userEmail: String!
    $barcodeLabelId: Int!
    $digits: Int
    $prefix: String
    $startNumber: Int
    $endNumber: Int
    $dataSource: String!
    $entityId: Int
    $fieldId: Int
    $id: ID
    $labelsToBeGenerated: Int
    $labelToBeGenerated: Int
    $totalRepeat: Int!
    $startPosition: Int!
    $token: String!
  ) {
    sendPdfRequest(
      input: {
        id: $id
        accountId: $accountId
        userId: $userId
        userEmail: $userEmail
        barcodeLabelId: $barcodeLabelId
        digits: $digits
        prefix: $prefix
        startNumber: $startNumber
        endNumber: $endNumber
        dataSource: $dataSource
        entityId: $entityId
        fieldId: $fieldId
        labelsToBeGenerated: $labelsToBeGenerated
        labelToBeGenerated: $labelToBeGenerated
        totalRepeat: $totalRepeat
        startPosition: $startPosition
        token: $token
      }
    ) {
      pdfData {
        location
      }
      errors
    }
  }
`
